<template>
    <v-toolbar>

        <v-toolbar-title>Front Door</v-toolbar-title>
        <v-spacer></v-spacer>
        <div>
            <v-btn id="btnA" :disabled="false" depressed color="primary" @click="buttonclick()">Open</v-btn>
            <v-btn flat icon>
                <v-icon style="font-size: 25px; padding: 0px">{{liveIcon}}</v-icon>
            </v-btn>
        </div>



    </v-toolbar>
</template>

<script>

    import axios from 'axios'

    export default {
        name: "DoorRow",
        data(){
            return {
                liveIcon: 'lock',
            }
        },
        methods: {
            buttonclick(){
                function getCookie(cname) {
                    var name = cname + "=";
                    var decodedCookie = decodeURIComponent(document.cookie);
                    var ca = decodedCookie.split(';');
                    for(var i = 0; i <ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') {
                            c = c.substring(1);
                        }
                        if (c.indexOf(name) == 0) {
                            return c.substring(name.length, c.length);
                        }
                    }
                    return "";
                }

                var token = "Bearer "+ getCookie("tokenL7TFiZuzFO");
                axios.get('https://homeautomation-proxy.appspot.com/frontdoor/open', {
                    headers: {
                        "Authorization": token
                    }
                }).then(response => {
                    if(response.status == '200'){
                        this.liveIcon = 'lock_open';
                        document.getElementById('btnA').classList.add('v-btn--disabled');

                        setTimeout(() => {
                            this.liveIcon = 'lock';
                            document.getElementById('btnA').classList.remove('v-btn--disabled')
                        }, 5000);
                    } else if (response.status == '500'){
                        console.log(response.data, response.status);
                    }
                }).catch((error) => {
                    if (error.response.status == '401'){
                        localStorage.removeItem('token');
                        this.$parent.$router.push('/login');
                    }
                    console.log(error.response.data);
                    console.log(error.response.status);
                })
            }
        }
    }
</script>

<style scoped>
    button[disabled] {
        opacity: 0.6;
    }
</style>